import * as RadixTooltip from '@radix-ui/react-tooltip';
import classNames from 'classnames';
import type { ReactNode } from 'react';

import './Tooltip.less';

interface TooltipProps {
  title: ReactNode;
  className?: string;
  children: ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
  disableHoverableContent?: boolean;
}

export const Tooltip = ({ title, className, children, disableHoverableContent = true, side = 'top' }: TooltipProps): ReactNode => {
  // If the title is falsy then just return the children
  if (!title) {
    return children;
  }

  return (
    <RadixTooltip.Provider>
      <RadixTooltip.Root delayDuration={0} disableHoverableContent={disableHoverableContent}>
        <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
        <RadixTooltip.Portal>
          <RadixTooltip.Content side={side} className={classNames('tooltip-content', className)} sideOffset={5}>
            {title}
            <RadixTooltip.Arrow className="tooltip-arrow" />
          </RadixTooltip.Content>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
};
